var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "vertical-progress-wrapper",
      class: !_vm.isEmptyTimeline ? "progress-vertical" : "",
      attrs: { id: "timeline-list" },
    },
    [
      _vm._l(_vm.timelineList, function (ref, idx) {
        var items = ref.items
        var sectionName = ref.sectionName
        return _c(
          "div",
          { key: sectionName + "-" + idx },
          [
            items[0]
              ? _c(
                  "div",
                  {
                    staticClass: "row mt-4",
                    class: _vm.toHyphens(sectionName) + "-section-item",
                  },
                  [
                    _c("div", { staticClass: "col-9 month-tag" }, [
                      _c(
                        "h4",
                        {
                          staticClass: "bold text-primary mb-4 text-capitalize",
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.isCurrentMonth(sectionName)
                                  ? _vm.t("client-profile.messages.thisMonth")
                                  : sectionName
                              ) +
                              "\n        "
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.timelineTab == "email"
                      ? _c(
                          "div",
                          { staticClass: "col-3 text-right" },
                          [
                            _c(
                              "b-dropdown",
                              {
                                staticClass: "m-md-2",
                                attrs: {
                                  id: "actions-dropdown",
                                  variant: "white",
                                  text: _vm.t("global.words.actions"),
                                },
                              },
                              [
                                _c(
                                  "b-dropdown-item",
                                  { on: { click: _vm.handleSummarizeEmail } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.t(
                                          "ai-email-summarization.summarizeAction"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-dropdown-item",
                                  { on: { click: _vm.handleDownloadToPDF } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("email.actions.downloadPDF")
                                      )
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm._l(
              _vm.getFilteredItems(sectionName, items),
              function (activityItem, itemIdx) {
                return _c(
                  "div",
                  {
                    key:
                      sectionName +
                      "-" +
                      activityItem.activityType +
                      "-" +
                      itemIdx,
                    staticClass: "row mb-4 timeline-item",
                    class: _vm.toHyphens(sectionName) + "-section-item",
                  },
                  [
                    _c("div", { staticClass: "progress-item col pr-0" }, [
                      _c(
                        "a",
                        {
                          directives: [
                            {
                              name: "b-tooltip",
                              rawName: "v-b-tooltip.left",
                              value: _vm.getTooltipTitle(activityItem),
                              expression: "getTooltipTitle(activityItem)",
                              modifiers: { left: true },
                            },
                          ],
                          staticClass:
                            "progress-item-circle nav-link clickable",
                          style:
                            "--progress-item-variation: " +
                            _vm.getItemVariation(activityItem.activityType),
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.handleIconClick(
                                activityItem.activityType
                              )
                            },
                          },
                        },
                        [
                          _c("i", {
                            class: _vm.parseClassItem(
                              activityItem.activityType
                            ),
                            staticStyle: {
                              "z-index": "50",
                              "font-size": "15px",
                              color: "white",
                            },
                          }),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col timeline-item-content-wrapper" },
                      [
                        _c(
                          "div",
                          [
                            _c(
                              _vm.getTimelineComponent(
                                activityItem.activityType
                              ),
                              _vm._b(
                                {
                                  key: _vm.activityItemKey(activityItem),
                                  tag: "component",
                                  attrs: {
                                    details: _vm.details,
                                    subscribers: _vm.subscribers,
                                    classname: "progress-item-image",
                                    "timeline-list": _vm.timelineList,
                                    items: items,
                                    "client-profile-id": _vm.clientProfileId,
                                    "board-id": _vm.boardId,
                                    "client-username": _vm.clientUsername,
                                    applications: _vm.applications,
                                  },
                                  on: { pin: _vm.pinItem },
                                },
                                "component",
                                Object.assign({}, activityItem),
                                false
                              )
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]
                )
              }
            ),
          ],
          2
        )
      }),
      _vm._v(" "),
      _vm.isEmptyTimeline
        ? _c("div", { staticClass: "row mt-5 pl-5" }, [
            _c("div", { staticClass: "col-12 text-center" }, [
              _c("img", {
                attrs: {
                  height: "100px",
                  src: require("@Broker/@Assets/icon/empty-timeline.png"),
                  alt: "",
                },
              }),
              _vm._v(" "),
              _c("h3", { staticClass: "text-gray mt-2" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.t("global.messages.noActivityToShow")) +
                    "\n      "
                ),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "disclaimer-modal",
            title: _vm.t("ai-email-summarization.disclaimerModalTitle"),
            "hide-footer": "",
          },
        },
        [
          _c("p", { staticClass: "text-center" }, [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.t("ai-email-summarization.disclaimer1", {
                    startDate: _vm.getSummarizationStartDate(),
                  })
                ) +
                "\n      "
            ),
            _c("br"),
            _c("br"),
            _vm._v(" "),
            _c("i", [
              _vm._v(_vm._s(_vm.t("ai-email-summarization.disclaimer2"))),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "text-right" },
            [
              _c(
                "b-button",
                {
                  attrs: { variant: "white" },
                  on: { click: _vm.cancelSummarize },
                },
                [_vm._v(_vm._s(_vm.t("ai-email-summarization.cancel")))]
              ),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  attrs: { variant: "primary" },
                  on: { click: _vm.continueSummarize },
                },
                [_vm._v(_vm._s(_vm.t("ai-email-summarization.continue")))]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "summarize-modal",
            title: _vm.loadingSummary
              ? _vm.t("ai-email-summarization.loadingSummarizeModalTitle")
              : _vm.t("ai-email-summarization.summarizeModalTitle"),
            size: "xl",
            "hide-footer": "",
          },
        },
        [
          _vm.loadingSummary
            ? _c("div", { staticClass: "loading-summary" }, [
                _c("div", { staticClass: "ld ld-ring ld-spin-fast huge" }),
              ])
            : _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-7" }, [
                  _c("h5", { staticClass: "text-center" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.t("ai-email-summarization.summaryView")) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "summary-view" },
                    [
                      _c("summarize-timeline", {
                        attrs: { timeline: _vm.summarizationTimelineItems },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-5" }, [
                  _c("div", { staticClass: "suggested-actions" }, [
                    _c("h5", { staticClass: "text-center" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.t("ai-email-summarization.suggestedActions")
                          ) +
                          "\n          "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "ul",
                      { staticClass: "summarize-suggested-actions" },
                      _vm._l(_vm.suggestedActions, function (action) {
                        return _c(
                          "li",
                          {
                            key: action.id,
                            staticClass: "summarize-suggested-actions-item",
                            on: {
                              click: function ($event) {
                                return _vm.handleActionClick(action)
                              },
                            },
                          },
                          [
                            action.action == "note"
                              ? _c("span", [
                                  _c("i", {
                                    staticClass:
                                      "fa fa-file-text-o text-primary icon-top-left",
                                    attrs: { "aria-hidden": "true" },
                                  }),
                                  _vm._v(" "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.t(
                                          "ai-email-summarization.actionNote"
                                        )
                                      ),
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("br"),
                                  _vm._v(
                                    "\n                " + _vm._s(action.text)
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            action.action == "reminder"
                              ? _c("span", [
                                  _c("i", {
                                    staticClass:
                                      "fa fa-calendar-plus-o text-primary icon-top-left",
                                    attrs: { "aria-hidden": "true" },
                                  }),
                                  _vm._v(" "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.t(
                                          "ai-email-summarization.actionReminder",
                                          {
                                            date: action.date,
                                          }
                                        )
                                      ),
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("br"),
                                  _vm._v(_vm._s(action.text)),
                                ])
                              : _vm._e(),
                          ]
                        )
                      }),
                      0
                    ),
                  ]),
                ]),
              ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "selected-action-modal",
            title: _vm.t("ai-email-summarization.createActionTitle", {
              actionName: _vm.selectedActionName,
            }),
            size: "xl",
            "hide-footer": "",
          },
        },
        [
          _c("div", { staticClass: "card" }, [
            _c(
              "div",
              { staticClass: "card-body" },
              [
                _c(
                  _vm.selectedActionComponent,
                  _vm._b(
                    {
                      ref: "ai-action-component",
                      tag: "component",
                      on: {
                        add: function ($event) {
                          return _vm.modal.hide("selected-action-modal")
                        },
                        submit: function ($event) {
                          return _vm.modal.hide("selected-action-modal")
                        },
                      },
                    },
                    "component",
                    _vm.selectedActionProps,
                    false
                  )
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }